import { HIDE_SAVING_MODAL } from "store/experiences/actionTypes"
import {
  PUT_MENU_ITEM_SUCCESS,
  SHOW_SAVING_MODAL,
  ADD_MENU_FEATURE,
  ADD_MENU_FEATURE_SUCCESS,
  ADD_MENU_FEATURE_FAILED,
  GET_MENU_ICONS,
  GET_MENU_ICONS_SUCCESS,
  GET_MENU_ICONS_FAILED,
  OPEN_SELECT_ICON_MODAL,
  HIDE_SELECT_ICON_MODAL,
  EDIT_MENU_ITEM,
  EDIT_MENU_ITEM_SUCCESS,
  EDIT_MENU_ITEM_FAILED,
  DELETE_MENU_ITEM,
  DELETE_MENU_ITEM_SUCCESS,
  DELETE_MENU_ITEM_FAILED,
  OPEN_DELETE_FEATURE_MODAL,
  HIDE_DELETE_FEATURE_MODAL,
  SET_ISOUTDATED,
  SET_SELECTED_FEATURE,
  UPLOAD_MENU_ITEM_IMAGE,
  UPLOAD_MENU_ITEM_IMAGE_SUCCESS,
  UPLOAD_MENU_ITEM_IMAGE_FAILED,
  GET_FEATURE_DEEPLINK_URL,
  GET_FEATURE_DEEPLINK_URL_SUCCESS,
  GET_FEATURE_DEEPLINK_URL_FAILED,
  GET_FEATURE_DEEPLINK_CODES,
  GET_FEATURE_DEEPLINK_CODES_SUCCESS,
  GET_FEATURE_DEEPLINK_CODES_FAILED,
  OPEN_GENERATE_FEATURE_DEEPLINK_MODAL,
  HIDE_GENERATE_FEATURE_DEEPLINK_MODAL,
  CLONE_MENU_FEATURE,
  CLONE_MENU_FEATURE_FAILED,
  CLONE_MENU_FEATURE_SUCCESS,
  DISPLAY_LOCK_WARNING_MODAL,
  HIDE_LOCK_WARNING_MODAL,
  SET_MENU_FEATURE_UPDATE_LOADING,
  OPEN_FEATURE_NOTIFICATION_MODAL,
  HIDE_FEATURE_NOTIFICATION_MODAL,
} from "./actionTypes"

export const addMenuFeature = params => ({
  type: ADD_MENU_FEATURE,
  payload: params,
})

export const addMenuFeatureSuccess = response => ({
  type: ADD_MENU_FEATURE_SUCCESS,
  payload: response,
})

export const addMenuFeatureFailed = error => ({
  type: ADD_MENU_FEATURE_FAILED,
  payload: error,
})

export const getMenuIcons = () => ({
  type: GET_MENU_ICONS,
  payload: {},
})

export const getMenuIconsSuccess = icons => ({
  type: GET_MENU_ICONS_SUCCESS,
  payload: icons,
})

export const getMenuIconsFailed = error => ({
  type: GET_MENU_ICONS_FAILED,
  payload: error,
})

export const openSelectIconModal = () => ({
  type: OPEN_SELECT_ICON_MODAL,
  payload: {},
})

export const hideSelectIconModal = () => ({
  type: HIDE_SELECT_ICON_MODAL,
  payload: {},
})

export const editMenuItem = params => ({
  type: EDIT_MENU_ITEM,
  payload: params,
})

export const editMenuItemSuccess = response => ({
  type: EDIT_MENU_ITEM_SUCCESS,
  payload: response,
})

export const editMenuItemFailed = error => ({
  type: EDIT_MENU_ITEM_FAILED,
  payload: error,
})

export const deleteMenuItem = menuItemId => ({
  type: DELETE_MENU_ITEM,
  payload: menuItemId,
})

export const deleteMenuItemSuccess = menuItemId => ({
  type: DELETE_MENU_ITEM_SUCCESS,
  payload: menuItemId,
})

export const deleteMenuItemFailed = error => ({
  type: DELETE_MENU_ITEM_FAILED,
  payload: error,
})

export const openDeleteFeatureModal = () => ({
  type: OPEN_DELETE_FEATURE_MODAL,
  payload: {},
})

export const hideDeleteFeatureModal = () => ({
  type: HIDE_DELETE_FEATURE_MODAL,
  payload: {},
})

export const putMenuItemSuccess = params => ({
  type: PUT_MENU_ITEM_SUCCESS,
  payload: params,
})

export const showSavingModal = () => ({
  type: SHOW_SAVING_MODAL,
  payload: {},
})

export const hideSavingModal = () => ({
  type: HIDE_SAVING_MODAL,
  payload: {},
})

export const setIsOutdated = value => ({
  type: SET_ISOUTDATED,
  payload: value,
})

export const setSelectedFeature = item => ({
  type: SET_SELECTED_FEATURE,
  payload: item,
})

export const uploadMenuItemImage = params => ({
  type: UPLOAD_MENU_ITEM_IMAGE,
  payload: params,
})

export const uploadMenuItemImageSuccess = response => ({
  type: UPLOAD_MENU_ITEM_IMAGE_SUCCESS,
  payload: response,
})

export const uploadMenuItemImageFailed = error => ({
  type: UPLOAD_MENU_ITEM_IMAGE_FAILED,
  payload: error,
})

export const getFeatureDeepLinkUrl = params => ({
  type: GET_FEATURE_DEEPLINK_URL,
  payload: params,
})

export const getFeatureDeepLinkUrlSuccess = response => ({
  type: GET_FEATURE_DEEPLINK_URL_SUCCESS,
  payload: response,
})

export const getFeatureDeepLinkUrlFailed = error => ({
  type: GET_FEATURE_DEEPLINK_URL_FAILED,
  payload: error,
})

export const getFeatureDeeplinkCodes = params => ({
  type: GET_FEATURE_DEEPLINK_CODES,
  payload: params,
})

export const getFeatureDeeplinkCodesSuccess = response => ({
  type: GET_FEATURE_DEEPLINK_CODES_SUCCESS,
  payload: response,
})

export const getFeatureDeeplinkCodesFailed = error => ({
  type: GET_FEATURE_DEEPLINK_CODES_FAILED,
  payload: error,
})

export const openGenerateFeatureDeeplinkModal = () => ({
  type: OPEN_GENERATE_FEATURE_DEEPLINK_MODAL,
  payload: {},
})

export const hideGenerateFeatureDeeplinkModal = () => ({
  type: HIDE_GENERATE_FEATURE_DEEPLINK_MODAL,
  payload: {},
})

export const cloneMenuFeature = params => ({
  type: CLONE_MENU_FEATURE,
  payload: params,
})

export const cloneMenuFeatureSuccess = response => ({
  type: CLONE_MENU_FEATURE_SUCCESS,
  payload: response,
})

export const cloneMenuFeatureFailed = error => ({
  type: CLONE_MENU_FEATURE_FAILED,
  payload: error,
})

export const displayLockWarningModal = () => ({
  type: DISPLAY_LOCK_WARNING_MODAL,
  payload: {},
})

export const hideLockWarningModal = () => ({
  type: HIDE_LOCK_WARNING_MODAL,
  payload: {},
})

export const setMenuFeatureUpdateLoading = params => ({
  type: SET_MENU_FEATURE_UPDATE_LOADING,
  payload: params,
})

export const openFeatureNotificationModal = () => ({
  type: OPEN_FEATURE_NOTIFICATION_MODAL,
  payload: {},
})

export const hideFeatureNotificationModal = () => ({
  type: HIDE_FEATURE_NOTIFICATION_MODAL,
  payload: {},
})
